import React from "react";
import { FaPlus, FaRedo, FaSearch, FaTimes } from "react-icons/fa";

import { getRoleOptions } from "../utils/usersManagerUtils";

export default function UsersToolbar({
  query,
  selectedRole,
  selectedSection,
  sections,
  loading,
  demoMode,
  onQueryChange,
  onRoleChange,
  onSectionChange,
  onReset,
  onRefresh,
  onCreate,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-white/10 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-primary via-indigo-500 to-emerald-500" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Administration
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              Gestion des utilisateurs
            </h1>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Gérez les comptes, les rôles, les sections associées et les accès
              à l’espace d’administration.
            </p>

            {demoMode && (
              <div className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-bold text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300">
                Mode démonstration actif : les actions de création,
                modification et suppression sont désactivées.
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onCreate}
              disabled={demoMode}
              className="inline-flex items-center gap-2 rounded-2xl bg-primary px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <FaPlus />
              Ajouter
            </button>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-white/10"
            >
              <FaRedo className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        <div className="mt-5 grid gap-3 lg:grid-cols-[minmax(240px,1fr)_220px_260px_auto]">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={query}
              onChange={(event) => onQueryChange(event.target.value)}
              placeholder="Rechercher nom, prénom ou email..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2.5 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-white"
            />
          </div>

          <select
            value={selectedRole}
            onChange={(event) => onRoleChange(event.target.value)}
            className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200"
          >
            <option value="">Tous les rôles</option>
            {getRoleOptions().map((role) => (
              <option key={role.id} value={role.id}>
                {role.label}
              </option>
            ))}
          </select>

          <select
            value={selectedSection}
            onChange={(event) => onSectionChange(event.target.value)}
            className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200"
          >
            <option value="">Toutes les sections</option>
            {sections.map((section) => (
              <option key={section.id} value={section.id}>
                {section.nom_section}
              </option>
            ))}
          </select>

          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-white/10"
          >
            <FaTimes />
            Réinitialiser
          </button>
        </div>
      </div>
    </div>
  );
}